import React from "react";

const CloudIcon = () => {
  return (
    <svg
      width="38"
      height="28"
      viewBox="0 0 38 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.55562 27.3333C7.12046 27.3333 5.03018 26.4676 3.28479 24.7361C1.53943 23.0046 0.666748 20.9213 0.666748 18.4861C0.666748 16.3195 1.34268 14.4028 2.69454 12.7361C4.04637 11.0695 5.79637 10.0463 7.94454 9.66667C8.54637 7.01853 9.87971 4.86112 11.9445 3.19446C14.0093 1.52779 16.3797 0.694458 19.0556 0.694458C22.2316 0.694458 24.9052 1.8264 27.0765 4.09029C29.2478 6.35418 30.3334 9.08335 30.3334 12.2778V12.9445C32.3056 12.9815 33.9654 13.6875 35.3126 15.0625C36.6598 16.4375 37.3334 18.1296 37.3334 20.1389C37.3334 22.1111 36.6274 23.8032 35.2154 25.2153C33.8033 26.6273 32.1112 27.3333 30.139 27.3333H20.389C19.639 27.3333 18.9885 27.0579 18.4376 26.507C17.8867 25.956 17.6112 25.3056 17.6112 24.5556V14.5278L14.4167 17.6944L12.4445 15.7222L19.0001 9.16667L25.5556 15.7222L23.5834 17.6944L20.389 14.5278V24.5556H30.139C31.3612 24.5556 32.4029 24.125 33.264 23.2639C34.1251 22.4028 34.5557 21.3611 34.5557 20.1389C34.5557 18.9167 34.1251 17.875 33.264 17.0139C32.4029 16.1528 31.3612 15.7222 30.139 15.7222H27.5556V12.2778C27.5556 9.86112 26.7246 7.78936 25.0626 6.0625C23.4006 4.33564 21.3612 3.47221 18.9445 3.47221C16.5279 3.47221 14.4839 4.33564 12.8126 6.0625C11.1413 7.78936 10.3056 9.86112 10.3056 12.2778H9.50008C7.81489 12.2778 6.38433 12.8704 5.20842 14.0555C4.03247 15.2407 3.4445 16.6944 3.4445 18.4167C3.4445 20.1019 4.04107 21.5463 5.23421 22.75C6.42732 23.9537 7.86779 24.5556 9.55562 24.5556H14.8335V27.3333H9.55562Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default CloudIcon;
